<template>
    <div class="srv-clt">
        <header class="srv-head">
            <button class="srv-icone-btn" aria-label="Retour" @click="$emit('fermer')">
                <i class="ri-arrow-left-line"></i>
            </button>
            <div>
                <div class="srv-head-titre">{{ table ? table.name : 'Table' }}</div>
                <div class="srv-head-sous">
                    {{ clients.length }} client{{ clients.length > 1 ? 's' : '' }} en cours
                </div>
            </div>
        </header>

        <div class="srv-corps">
            <!-- Plusieurs clients peuvent partager une table : on liste les
                 additions en cours pour en reprendre une, ou on en ouvre une
                 nouvelle. Chacune reste une addition distincte. -->
            <p class="srv-clt-hint">
                <i class="ri-information-line"></i>
                Reprenez un client pour compléter sa commande, ou ouvrez-en un nouveau.
            </p>

            <button v-for="c in clients" :key="c.id" class="srv-clt-item" @click="$emit('reprendre', c)">
                <div class="srv-clt-l1">
                    <span class="srv-clt-nom">{{ labelClient(c) }}</span>
                    <span class="srv-clt-mtnt srv-num">{{ fmt(totalCommande(c)) }}</span>
                </div>
                <div class="srv-clt-l2">
                    <span class="srv-clt-meta">
                        {{ nbArticles(c) }} article{{ nbArticles(c) > 1 ? 's' : '' }}
                    </span>
                    <span class="srv-pill" :class="'srv-pill-' + STATUTS[c.statut].ton">
                        {{ STATUTS[c.statut].libelle }}
                    </span>
                </div>
            </button>
        </div>

        <div class="srv-barre">
            <button class="srv-btn" @click="$emit('nouveau')">
                <i class="ri-user-add-line"></i>
                <span>Nouveau client</span>
            </button>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import { fmt } from "../menu/format";
    import { STATUTS, labelClient } from "./statuts";

    export default {
        name: "srvclientstable",
        props: {
            table: { type: Object, default: null },
            clients: { type: Array, default: () => [] },
        },
        emits: ["reprendre", "nouveau", "fermer"],
        data: () => ({ STATUTS }),
        methods: {
            fmt,
            labelClient,
            totalCommande(c) { return c.lignes.reduce((s, l) => s + l.pu * l.qte, 0); },
            nbArticles(c) { return c.lignes.reduce((s, l) => s + l.qte, 0); },
        },
    };
</script>

<style scoped>
    .srv-clt { display: flex; flex-direction: column; min-height: 100vh; }

    .srv-clt-hint {
        display: flex; align-items: flex-start; gap: 8px;
        margin: 0 0 var(--srv-md); padding: 10px 12px;
        background: var(--srv-info-soft); border-radius: var(--srv-r-input);
        font-size: 13px; line-height: 1.4; color: var(--srv-info);
    }
    .srv-clt-hint i { font-size: 16px; flex-shrink: 0; margin-top: 1px; }

    .srv-clt-item {
        display: block; width: 100%; text-align: left; cursor: pointer;
        margin-bottom: var(--srv-sm); padding: 14px;
        background: var(--srv-surface); color: var(--srv-on);
        border: 1px solid var(--srv-outline-variant); border-radius: var(--srv-r);
        font-family: inherit;
    }
    .srv-clt-item:hover { border-color: var(--srv-primary); }

    .srv-clt-l1 { display: flex; align-items: center; justify-content: space-between; gap: var(--srv-sm); }
    .srv-clt-nom { font-size: 16px; font-weight: 700; }
    .srv-clt-mtnt { font-size: 16px; font-weight: 800; white-space: nowrap; }

    .srv-clt-l2 {
        display: flex; align-items: center; justify-content: space-between;
        gap: var(--srv-sm); margin-top: var(--srv-sm);
    }
    .srv-clt-meta { font-size: 13px; color: var(--srv-on-variant); }
</style>
